import { useId, type InputHTMLAttributes, type ReactNode } from "react";
import { Icon, type IconName } from "./Icon";

export interface TextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "prefix"> {
  label?: string;
  hint?: string;
  error?: string;
  icon?: IconName;
  prefix?: ReactNode;
  suffix?: ReactNode;
}

/** Beschriftetes Eingabefeld, 48 px hoch, 17 px Schrift. `error` ersetzt den Hinweis und färbt den Rand. */
export function TextField({ label, hint, error, icon, prefix, suffix, id, className, ...rest }: TextFieldProps) {
  const autoId = useId();
  const inputId = id ?? autoId;
  const msgId = `${inputId}-msg`;
  return (
    <div className={["rg-field", error && "rg-field--error", className].filter(Boolean).join(" ")}>
      {label ? (
        <label className="rg-field__label" htmlFor={inputId}>
          {label}
        </label>
      ) : null}
      <div className="rg-field__box">
        {icon ? <Icon name={icon} size={20} className="rg-field__icon" /> : null}
        {prefix ? <span className="rg-field__affix">{prefix}</span> : null}
        <input id={inputId} className="rg-field__input" aria-invalid={error ? true : undefined} aria-describedby={hint || error ? msgId : undefined} {...rest} />
        {suffix ? <span className="rg-field__affix">{suffix}</span> : null}
      </div>
      {error ? (
        <p className="rg-field__msg rg-field__msg--error" id={msgId} role="alert">
          <Icon name="circle-alert" size={16} /> {error}
        </p>
      ) : hint ? (
        <p className="rg-field__msg" id={msgId}>
          {hint}
        </p>
      ) : null}
    </div>
  );
}
